// extracted by extract-css-chunks-webpack-plugin
    if(module.hot) {
      // 1776855336395
      var cssReload = require("/var/www/html/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"reloadAll":true,"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  